<template>
  <div id="app" class="col-md-5 col-xs-12 col-sm-12 col-12">
    <h1 class="big-title text-left-desktop">{{ $t('m26') }}</h1>
    <p class="description-page md-text-center">
      {{ $t('m28') }}
    </p>
    <form @submit="checkForm">
      <a-input
        name="password"
        :label="$t('m29')"
        class="mt2"
        :type="showPassword ? 'text' : 'password'"
        v-model="form.password.value"
        :append-text="showPassword ? $t('m10') : $t('m11')"
        @click-append="showPassword = !showPassword"
        @keyup="evaluateInput"
        :error="form.password.error.length > 0"
        :errorMessage="form.password.error"
      />

      <a-input
        name="confirmPassword"
        :label="$t('m30')"
        class="mt2"
        :type="showPassword2 ? 'text' : 'password'"
        v-model="form.confirmPassword.value"
        :append-text="showPassword2 ? $t('m10') : $t('m11')"
        @click-append="showPassword2 = !showPassword2"
        @keyup="evaluateInput"
        :error="form.confirmPassword.error.length > 0"
        :errorMessage="form.confirmPassword.error"
      />

      <a-btn type="submit" class="mt2" primary :loading="loading">{{
        $t('m31')
      }}</a-btn>
    </form>
  </div>
</template>

<script>
import AInput from '@/components/ui/AInput';
import ALink from '@/components/ui/ALink';
import ABtn from '@/components/ui/ABtn';
import { validator } from '@/mixins/validator.js';

export default {
  components: {
    ALink,
    AInput,
    ABtn,
  },
  mixins: [validator],
  data() {
    return {
      loading: false,
      showPassword: false,
      showPassword2: false,
      form: {
        password: {
          value: '',
          error: '',
          rules: [],
        },
        confirmPassword: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      if (this.validateForm()) {
        this.loading = true;
        const changePassword = {
          password: this.form.password.value,
          token: this.$route.query.token,
        };
        this.$store
          .dispatch('register/changePassword', changePassword)
          .then(resp => {
            if (resp.successful) {
              this.$toast.success('La contraseña fue cambiada correctamente');
            } else {
              this.$toast.error(
                'El token no es válido, inicie el proceso nuevamente',
              );
            }
            location.href = '/admin/login/customers';
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.form.password.rules = [this.rules.required, this.rules.password];
    this.form.confirmPassword.rules = [
      this.rules.required,
      value =>
        value === this.form.password.value || 'Las contraseñas deben coincidir',
    ];
  },
};
</script>
